import {faSearch} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  Button,
  ContentLayout,
  Content,
  InputBox,
  ListTable,
  SearchFilter,
  Img,
  RadioBox,
  CheckBox,
} from "@adminComponents";
import * as Datas from "@adminData";
import React, {useEffect, useState} from "react";
import {useSetRecoilState} from "recoil";
import {states} from "@recoils";
import {useAdminNav} from "@hook";
import {adminApi} from "@utils";
import styles from "./style.module.scss";
import {AdminScreenId} from "@assets";
import moment from "moment";
import _ from "lodash";

export default function Page() {
  const setAlertModal = useSetRecoilState(states.alertState);
  const {getParams, navigate} = useAdminNav();
  const {searchTxt: paramsSearchTxt, page: paramsPage = 1} = getParams<{
    searchTxt?: string;
    page?: number;
  }>();
  const [searchTxt, setSearchTxt] = useState(paramsSearchTxt);
  const [listData, setListData] =
    useState<Datas.ResultPagingResponse<Datas.IPopupResponse[]>>();

  async function getList({page = 1}: {page?: number} = {}) {
    try {
      const {data, success, message} = await adminApi.popup.getList({
        page,
        searchTxt,
      });
      if (success) {
        setListData(data);
      } else {
        setAlertModal({
          isVisible: true,
          title: message || "오류가 발생했습니다",
        });
      }
    } catch (error) {
      console.error("getList error", error);
    }
  }

  function goToDetail({data}: {data?: Datas.IPopup} = {}) {
    navigate({
      url: AdminScreenId.POPUP_DETAIL,
      params: {no: data?.no},
      state: {data},
    });
  }

  function goToListPage(params: {
    group?: string;
    group2?: string;
    searchTxt?: string;
    page?: number;
  }) {
    navigate({
      url: AdminScreenId.POPUP,
      params,
    });
  }

  useEffect(() => {
    getList({page: paramsPage});
  }, [location.search]);

  return (
    <div className={styles.container}>
      <ContentLayout title={"팝업관리"}>
        <SearchFilter
          left={[
            <InputBox
              key={1}
              value={searchTxt}
              onValue={setSearchTxt}
              onEnter={() => {
                goToListPage({page: 1, searchTxt});
              }}
              rightContent={
                <div
                  style={{display: "flex"}}
                  onClick={() => {
                    goToListPage({page: 1, searchTxt});
                  }}>
                  <FontAwesomeIcon icon={faSearch} />
                </div>
              }
            />,
          ]}
          right={[<Button key={0} text="신규등록" onClick={goToDetail} />]}
        />
        <Content>
          <>
            <ListTable
              paging={listData?.page}
              getList={({page: newPage}) => {
                goToListPage({
                  page: newPage,
                  searchTxt,
                });
              }}>
              <thead>
                <tr>
                  <th>번호</th>
                  <th>이미지</th>
                  <th>제목</th>
                  <th>시작일</th>
                  <th>종료일</th>
                  <th>상태</th>
                  <th>등록일</th>
                </tr>
              </thead>
              <tbody>
                {(listData?.result || []).length === 0 ? (
                  <tr>
                    <td colSpan={6}>조회된 내용이 없습니다.</td>
                  </tr>
                ) : (
                  <>
                    {(listData?.result || []).map(item => {
                      const imgUrl = item.files?.[0]?.url;
                      const startDate =
                        !!item.start_date && moment(item.start_date).isValid()
                          ? moment(item.start_date)
                          : undefined;
                      const endDate =
                        !!item.end_date && moment(item.end_date).isValid()
                          ? moment(item.end_date)
                          : undefined;
                      const now = moment();
                      const status = (() => {
                        if (!startDate && !endDate) {
                          return "상시노출";
                        }
                        const start = startDate?.clone().startOf("day");
                        const end = endDate?.clone().endOf("day");
                        if (start && now.isBefore(start)) {
                          return "시작전";
                        }
                        if (
                          (!start || now.isSameOrAfter(start)) &&
                          (!end || now.isSameOrBefore(end))
                        ) {
                          return "게시중";
                        }
                        return "게시종료";
                      })();

                      return (
                        <tr
                          key={item.no}
                          onClick={() => goToDetail({data: item})}>
                          <td>{item.no}</td>
                          <td>
                            <Img src={imgUrl} />
                          </td>
                          <td>{item.title}</td>
                          <td>
                            {!startDate
                              ? ""
                              : moment(startDate).format("YYYY.MM.DD")}
                          </td>
                          <td>
                            {!endDate
                              ? ""
                              : moment(endDate).format("YYYY.MM.DD")}
                          </td>
                          <td>{status}</td>
                          <td>
                            {moment(item.created_at).format("YYYY-MM-DD")}
                          </td>
                        </tr>
                      );
                    })}
                  </>
                )}
              </tbody>
            </ListTable>
          </>
        </Content>
      </ContentLayout>
    </div>
  );
}
